import { Modal } from 'hljd'
import Api from '@api/system'
import { SHOP_LOGIN_PATH } from '@constant'

/**
 * 清除登录信息
 */
export const clearLoginStorage = () => {
  sessionStorage.clear()

  // 自动登录用户信息
  localStorage.removeItem('_name')
  localStorage.removeItem('_password')
  localStorage.removeItem('_time')
}

export const logout = async () => {
  const { success } = await Api.logout()

  if (success) {
    clearLoginStorage()
    window.location.href = SHOP_LOGIN_PATH
  }
}

export const logoutAction = () => {
  Modal.confirm({
    title: '确定退出？',
    onOk: () => {
      logout()
    }
  })
}
